import React from 'react'
import { Redirect } from 'react-router-dom'
import { useAuthState } from 'react-firebase-hooks/auth'
import PasswordReset from '@BUP/components/PasswordReset'
import { auth } from '@BUP/configs/Firebase'

export default function ResetPasswordPage () {
  const [authUser, authLoading, authError] = useAuthState(auth)
  if (authError) return <p>authError: {authError.message}</p>
  if (authUser) return <Redirect to='/' />
  if (!authUser && authLoading) return <p>auth loading</p>
  return (
    <div>
      <PasswordReset />
    </div>
  )
}
